
<!--<app-alerts></app-alerts>-->
<main>
  <section>
    <div class="container-fluid ptb-42">
      <div class="row">
        <div class="col-auto">
          <div class="titles-bdr-r">
            <h1 class="color-primary fs-325remTitles">{{contactsInfo.Titulo_Pagina}}</h1>
          </div>
        </div>
      </div>
    </div>
  </section>
  <section>
    <div class="container pb-120 gx-5 gx-lg-0">
      <div class="row justify-content-center">
        <div class="col-lg-8 col-12">
          <h3 class="color-primary fw-500">{{contactsInfo.Titulo_Seccao}}</h3>
          <h4>{{contactsInfo.Descricao_Seccao}}</h4>
          <p [innerHTML]="contactsInfo.Lista_Seccao"></p>
        </div>
      </div>
      <div class="row justify-content-center pt-60">
        <div class="col-lg-auto col-12 align-self-center">
          <div class="m-0 text-center">
            <a [href]="phoneLink" class="btn-number-contacts fs-20px"><i class="uil uil-phone-volume fs-20px me-2 color-white"></i>{{phoneNumberGeneral}}</a>
            <p class="bold fs-20px mt-3 mb-0">{{contactsInfo.Descricao_Linha_Contactos}}</p>
            <p>{{contactsInfo.Aviso_Linha_Contactos}}</p>
          </div>
        </div>
      </div>
      <!--
      <div class="row justify-content-center pt-60">
        <div class="col-lg-8 col-12">
          <h5 class="text-lg-start text-center">{{contactsInfo.Titulo_Areas_Contactos}}</h5>
          <img src="../../../../assets/img/CIMMapSvg.svg" class="img-fluid" alt="Mapa Áreas Linhas">
        </div>
      </div>
      -->
      <div class="row justify-content-center pt-120">
        <div class="col-lg-4 col-12 text-center align-self-center mb-5 mb-lg-0">
          <h5>{{contactsInfo.Titulo_Botoes_Apoio}}</h5>
          <p class="fw-600">{{contactsInfo.Descricao_Botoes_Apoio}}</p>
          <button title="Botão Apoio ao Passageiro" class="btn-custom btn-3 my-lg-3 mb-3" [routerLink]="'/apoio-passageiros'"><span><p class="my-auto fw-600">{{contactsInfo.Botao_Apoio}}</p><i class="uil uil-arrow-up-right color-white ms-2"></i></span></button>
        </div>
        <div class="col-lg-4 col-12 text-center align-self-center mb-5 mb-lg-0">
          <h5>{{contactsInfo.Titulo_Botoes_FAQ}}</h5>
          <p class="fw-600">{{contactsInfo.Descricao_Botoes_FAQ}}</p>
          <button title="Botão FAQ" class="btn-custom btn-3 my-lg-3 mb-3" [routerLink]="'/faq'"><span><p class="my-auto fw-600">{{contactsInfo.Botao_FAQ}}</p><i class="uil uil-arrow-up-right color-white ms-2"></i></span></button>
        </div>
      </div>
    </div>
  </section>
</main>

